import { push } from "react-router-redux";
import * as Blockv from "../MainBv.js"

const FETCH_TEMPLATES_PAGE_SIZE: number = 2;

interface TemplatesState {
	all: any[];
	pageNumber: number;
	fetchStatus: RequestStatus;
}

const INITIAL_CURRENT_USER_STATE: TemplatesState = {
	all: [],
	pageNumber: 0,
	fetchStatus: "",
};

export default (
	state: TemplatesState = INITIAL_CURRENT_USER_STATE,
	action: any
): TemplatesState => {
	switch (action.type) {
		case "TEMPLATES/FETCH_TEMPLATES/PENDING": {
			return {
				...state,
				fetchStatus: "pending",
			};
		}

		case "TEMPLATES/FETCH_TEMPLATES/SUCCESS": {
			const merged = [...state.all];

			for (const template of action.data.templates) {
				if (!merged.some(t => t.name === template.name)) {
					merged.push(template);
				}
			}

			return {
				...state,
				fetchStatus: "success",
				all: merged,
				pageNumber: action.data.pageNumber + 1,
			};
		}

		case "TEMPLATES/FETCH_TEMPLATES/FAILURE": {
			return {
				...state,
				fetchStatus: "failure",
			};
		}
	}

	return state;
};

export const actions = {
	fetchTemplates: (pageNumber: number) => async dispatch => {
		dispatch({ type: "TEMPLATES/FETCH_TEMPLATES/PENDING" });

		try {
			const res = await fetch(
				`${
					process.env.BLOCKV_API_URL
				}/v1/templates?%29&page%5Bnumber%5D=${pageNumber}&page%5Bsize%5D=${FETCH_TEMPLATES_PAGE_SIZE}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						"App-Id": Blockv.instance.store.appID,
						Authorization: `Bearer ${Blockv.instance.UserManager.getAccessToken()}`,
					},
					mode: "cors",
				}
			);

			if (res.status !== 200) {
				throw await res.json();
			}

			const templates = (await res.json()).payload;

			return dispatch({
				type: "TEMPLATES/FETCH_TEMPLATES/SUCCESS",
				data: {
					templates,
					pageNumber,
				},
			});
		} catch (e) {
			return dispatch({ type: "TEMPLATES/FETCH_TEMPLATES/FAILURE" });
		}
	},
};

// helper to get this reducer's state as a typed value
const templatesState = state => state.templates as TemplatesState;

export const selectAllTemplates = state => templatesState(state).all;
export const selectAllTemplatesFetchStatus = state => templatesState(state).fetchStatus;



// WEBPACK FOOTER //
// ./src/reducers/templates.ts